import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.TransactionRestService
 *
 * @description
 * This class contains methods used to manage information about transactions
 * using http requests.
 * https://portal.avira.org/display/CSIN/Transactions+Resource
 */
export default class TransactionRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.TransactionRestService#getAllAsync
     * @methodOf rest.services.TransactionRestService
     * @function
     *
     * @description
     * Retrieves the transactions.
     *
     * @returns {Promise} The promise of the call.
     */
    getAllAsync() {

        return super.getAllAsync('transactions?filter[operation]=payment');

    }

    /**
     * @ngdoc function
     * @name rest.services.TransactionRestService#getPageAsync
     * @methodOf rest.services.TransactionRestService
     * @function
     *
     * @description
     * Retrieves a single page of transactions from the backend.
     *
     * @param {string} pageLink The link to the requested page
     *
     * @returns {Promise} The promise of the call.
     */
    getPageAsync(pageLink) {

        return super.getPageAsync('transactions?filter[operation]=payment', pageLink);

    }

}

_serviceDependencies.push(TransactionRestService);

angular.module('rest.services')
    .service('TransactionRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/transactionRestService.js